var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbox-header"},[_c('button',{staticClass:"btn-icon icon-close",attrs:{"disabled":_vm.loading},on:{"click":_vm.closeToolbox}}),_c('h2',[_vm._v("Profil bearbeiten")])])}
var staticRenderFns = []

export { render, staticRenderFns }